import { ReactBrick, useProperty, getLogger } from '@olympeio/core';
import { BrickContext, registerBrick } from 'olympe';
import { AdvancedSearchInput } from '../shared/AdvancedSearchInput.jsx';
import { AdvancedSearchTemplate } from '../shared/AdvancedSearchTemplate.jsx';
import { AdvancedSearchKey } from '../shared/_enums';
import React from 'react';
import { AdvancedMasterDataSearchInput } from '../shared/AdvancedMasterDataSearchInput.jsx';

export default class CostCenterAdvancedSearchPopup extends ReactBrick {
    init($) {
        // $.observe('Selected Approvers', true).subscribe((list) => {
        //     if (list !== null && list.length > 0) {
        //         $.trigger('Clear Cost Centers');
        //     }
        // });
        // $.observe('Selected Cost Centers', true).subscribe((list) => {
        //     if (list !== null && list.length > 0) {
        //         $.trigger('Clear Approvers');
        //     }
        // });
        $.set('Selected Approvers', []);
        $.set('Selected Cost Centers', []);
        $.set('Selected Agents', []);
    }

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {!Array<*>} properties
     * @returns {Element}
     */

    static getReactComponent($) {
        const getOptions = $.get('get options');

        return (props) => {
            const hidden = useProperty($, 'Hidden');
            const operation = useProperty($, 'Operation'); // Should be either 'PO' or 'PR'
            const approvers = useProperty($, 'Approvers');
            const agents = useProperty($, 'Agents');
            const selectedApprovers = useProperty($, 'Selected Approvers');
            const selectedAgents = useProperty($, 'Selected Agents');

            const costCenters = useProperty($, 'Cost Centers');
            const selectedCostCenters = useProperty($, 'Selected Cost Centers');
            const purchaseGroups = useProperty($, 'Purchase Groups');
            const selectedPurchaseGroups = useProperty($, 'Selected Purchase Groups');
            const isFullScreen = useProperty($, 'Is Full Screen');
            const image = useProperty($, 'Image');

            const logger = getLogger('CostCenterAdvancedSearchPopup');

            const isValid =
                selectedApprovers?.length > 0 ||
                selectedAgents?.length > 0 ||
                (operation === 'PO' && selectedPurchaseGroups?.length > 0) ||
                (operation === 'PR' && selectedCostCenters?.length > 0);

            const handleClose = () => {
                $.trigger('Apply Cost Center Advanced Search');
                $.set('Hidden', true);
            };

            const handleClear = () => {
                // $.trigger('Clear Approvers');
                // $.trigger('Clear Cost Centers');
                $.trigger('Clear');
            };

            const searchFields = (
                <>
                    {operation === 'PR' && (
                        <AdvancedSearchInput context={$} data={costCenters} searchKey={AdvancedSearchKey.COST_CENTER} />
                    )}
                    {operation === 'PO' && (
                        <AdvancedSearchInput
                            context={$}
                            data={purchaseGroups}
                            searchKey={AdvancedSearchKey.PURCHASE_GROUP}
                        />
                    )}
                    <AdvancedSearchInput context={$} data={approvers} searchKey={AdvancedSearchKey.APPROVER} />
                    <AdvancedMasterDataSearchInput
                        context={$}
                        logger={logger}
                        filter={(value) => `IdNo eq '01' and SearchTerm eq '${value}'`}
                        getOptions={getOptions}
                        data={agents}
                        path={'PositionIdSet'}
                        searchKey={AdvancedSearchKey.AGENT}
                        title={'Position'}
                    />
                </>
            );

            return (
                !hidden && (
                    <AdvancedSearchTemplate
                        image={image}
                        searchFields={searchFields}
                        isFullScreen={isFullScreen}
                        cannotApply={!isValid}
                        handleClose={handleClose}
                        handleClear={handleClear}
                    />
                )
            );
        };
    }
}

registerBrick('017f8ce9a6ad24647bc5', CostCenterAdvancedSearchPopup);
